import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

export default function MiniStrip() {
  const minis = [IMAGES.mini1, IMAGES.mini2, IMAGES.mini3];

  return (
    <section className="relative py-14 md:py-20 bg-cream-2" data-testid="mini-strip">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-3 gap-3 md:gap-5">
          {minis.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: i * 0.08 }}
              className="group overflow-hidden rounded-xl md:rounded-2xl"
              data-testid={`mini-${i}`}
            >
              <img
                src={src}
                alt="Steve Massage à domicile"
                className="w-full h-32 sm:h-44 md:h-56 object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
